import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ThemeToggle from '../components/ThemeToggle';
import '../App.css';

function LegalLayout({ title, updated, children }) {
  const location = useLocation();

  useEffect(() => {
    const prevTitle = document.title;
    document.title = `${title} | Orca Transports Ltd`;

    const canonical = document.querySelector('link[rel="canonical"]');
    const prevCanonical = canonical ? canonical.href : null;
    if (canonical) canonical.href = `https://www.orcatransports.com${location.pathname}`;

    return () => {
      document.title = prevTitle;
      if (canonical && prevCanonical) canonical.href = prevCanonical;
    };
  }, [title, location.pathname]);

  return (
    <div className="page-wrapper">
      <nav className="navbar navbar-solid">
        <Link to="/" className="logo">ORCA TRANSPORTS</Link>
        <div className="nav-right">
          <Link to="/" className="back-link">← Back to site</Link>
          <ThemeToggle />
        </div>
      </nav>

      <section className="section legal-section">
        <h1 className="legal-title">{title}</h1>
        <p className="legal-updated">Last updated: {updated}</p>
        <div className="legal-body">
          {children}
        </div>
      </section>

      <footer>
        <h3>ORCA TRANSPORTS LTD</h3>
        <p>Victory House, Luton</p>
        <div className="footer-links">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <span className="footer-dot">•</span>
          <Link to="/terms-of-service">Terms of Service</Link>
        </div>
        <p>© 2026 Orca Transports Ltd.</p>
      </footer>
    </div>
  );
}

export default LegalLayout;
